import {axiosFileNodeClient, axiosNodeClient} from '../http';

export const customerServiceNode = {
    uploadFileCSVCustomer,
    get,
    getByPhone,
    searchText,
    updateGroupInCustomer,
    create,
    signup,
    update,
    del,
    countTotal
}

function uploadFileCSVCustomer(file) {
    let formData = new FormData();
    formData.append('file', file);

    return axiosFileNodeClient.post('/customer/csv', formData);
}

function get(id) {
    if (id && id > 0) {
        return axiosNodeClient.get(`/customer/${id}`);
    } else {
        return axiosNodeClient.get('/customer');
    }
}

function getByPhone(phone) {
    return axiosNodeClient.get('/customer', {
        params: {
            filter: 'byphone',
            phone_number: phone
        }
    });
}

function create(customer) {
    return axiosNodeClient.post('/customer', customer)
}


/**
 * Create new customer when customer check-in and sign-up
 */
function signup(customer) {
    return axiosNodeClient.post('/customer/signup', customer)
}

function update(customer) {
    return axiosNodeClient.put(`/customer/${customer.id}`, customer)
}

function del(id) {
    return axiosNodeClient.delete(`/customer/${id}`)
}

function searchText(optionSearch) {
    return axiosNodeClient.get('/customer/search', {
        params: {...optionSearch}
    });
}

function countTotal() {
    return axiosNodeClient.get('/customer/total',  {
        params: {
            action: 'total'
        }
    });
}

function updateGroupInCustomer(customerId, groupsInArr) {
    return axiosNodeClient.put(`/customer/${customerId}/group`, groupsInArr)
}
